function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import PropTypes from 'prop-types';
import React, { Component, createRef } from 'react';
import cx from 'classnames';

var Tile =
/*#__PURE__*/
function (_Component) {
  _inherits(Tile, _Component);

  function Tile(props) {
    var _this;

    _classCallCheck(this, Tile);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Tile).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "fillImage", function () {
      var image = _this.props.image;
      if (_this._image) _this._image.style.backgroundImage = "url(".concat(image, ")");
    });

    _this._image = createRef();
    return _this;
  }

  _createClass(Tile, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.fillImage();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.fillImage();
    }
    /**
     * fillImage method helps with hack for having tile image be squared.
     */

  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          image = _this$props.image,
          children = _this$props.children,
          onClick = _this$props.onClick;
      return React.createElement("div", {
        className: "Tile",
        onClick: onClick
      }, React.createElement("div", {
        className: "row"
      }, image ? React.createElement("div", {
        className: "Tile-image-column col-xs-4"
      }, React.createElement("div", {
        className: "Tile-image-column-inner",
        ref: this._image
      })) : null, React.createElement("div", {
        className: cx('Tile-column', {
          'col-xs-8': image,
          'col-xs-12': !image
        })
      }, children)));
    }
  }]);

  return Tile;
}(Component);

_defineProperty(Tile, "propTypes", {
  image: PropTypes.string,
  children: PropTypes.any,
  onClick: PropTypes.func
});

export { Tile as default };